// extracted by mini-css-extract-plugin
export default {"icon":"chip_icon__XmdEn","root":"chip_root__+rd5E"};